<div class="flex flex-col w-full  mx-auto">
  <div class="flex w-full mt-3">
    <div class="w-1/2">
      <p class="bold">{{ model().dba }}</p>
      <p><span>Contractors License Number: </span>{{ model().contractorLicenseNumber }}</p>
    </div>
    <div class="w-1/2">
      <p><span class="bold">Retail Agency: </span>{{ model().agencyName }}</p>
      <p><span class="bold">Retail Producer: </span>{{ model().producerName }}</p>
    </div>
  </div>

  <div class="flex w-full mt-3">
    <div class="w-1/2">
      <p><span class="bold">Business Type: </span>{{ model().businessType }}</p>
      <p class="bold">Primary Business Address:</p>
      <p>{{ model().address1 }} {{ model().address2 }}</p>
      <p>{{ model().city }}, {{ model().state }} {{ model().zip }}</p>
    </div>
    <div class="w-1/2"></div>
  </div>
</div>
